<template>
  <div v-if="getActiveVariationFilters.length > 0 || getActiveAttributeFilters.length > 0" class="listing-filters-clear-all">
    <a
      class="listing-filters-clear-all-link"
      :href="urlNoFilters"
    >
      {{ t('variation.listing.clear.all') }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdvClearListingFilters',
  props: [],
  computed: {
    ...mapGetters([
      'getActiveVariationFilters',
      'getActiveAttributeFilters',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'config'
    ]),
    urlNoFilters () {
      const url = '/' + this.config.url.lang + this.getUriWithoutOffset
      if (this.getIsTopLevelCategory) {
        return url + '/1'
      }
      return url
    }
  }
}
</script>

<style lang="scss" scoped>
.listing-filters {
  &-clear-all {
    width: 100%;
    margin-bottom: 1rem;
    position: relative;
    display: grid;
    justify-items: start;
    justify-content: start;
    &-link {
      padding: 5px;
      background: #ebf6ff;
      border-radius: 5px;
    }
  }
}
</style>
